import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ActivateSensorPayload } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  uniqueId: string
  options?: Omit<UseMutationOptions<unknown, Error, ActivateSensorPayload>, 'mutationKey' | 'mutationFn'>
}

export const useActivateSensorRequest = ({ uniqueId, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, ActivateSensorPayload>(
    [Entities.Sensors, 'activate', uniqueId],
    async (payload: ActivateSensorPayload) => {
      const { data } = await api.v1AdminSensorsUniqueIdActivatePost(uniqueId, payload)
      return data
    },
    {
      ...options
    }
  )
}
